/**
 * Email Status Logs — Super Admin view.
 *
 *  A focused feed of every email this app has produced, with KPI cards,
 *  Type / Status / date filters, and a click-through preview of the
 *  exact message that was delivered.
 *
 *  The page body is the shared <SentEmailsView /> — the Company Admin
 *  "Email Status Logs" page renders the same component against its own
 *  tenant-scoped endpoint. This wrapper just owns the Super Admin
 *  chrome (breadcrumb, title, help) and points the view at the
 *  cross-tenant `/super-admin/email-logs` surface.
 */
import { ScrollText } from 'lucide-react'
import { Breadcrumb } from '../../components/Breadcrumb'
import { SentEmailsView } from '../../components/SentEmailsView'

export function SentEmailsPage() {
  return (
    <div>
      <Breadcrumb current="Email Status Logs" homePath="/super-admin/dashboard" />

      <div className="mb-6">
        <h1 className="font-display text-3xl text-[color:var(--color-ink-strong)] flex items-center gap-3">
          <ScrollText
            size={22}
            className="text-[color:var(--color-accent-strong)]"
          />
          Email Status Logs
        </h1>
        <p className="mt-1 text-sm text-[color:var(--color-ink-muted)]">
          Every email the app has sent, with its delivery status.
        </p>
      </div>

      {/* apiBase points at the /platform/ variant — the correct
       *  implementation with real server-side pagination + filter-aware
       *  counts (`email-logs.routes.js`). The bare `/super-admin/email-logs`
       *  route in `modules.routes.js` predates it: it hard-caps
       *  responses at 200 rows without a `pagination` envelope, and
       *  the counts endpoint ignores every filter — so the KPI card
       *  disagreed with the pagination footer (QA bug 0016622). */}
      <SentEmailsView apiBase="/super-admin/platform/email-logs" />
    </div>
  )
}
